import React, {useRef, useLayoutEffect, useState} from "react";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4plugins_wordCloud from "@amcharts/amcharts4/plugins/wordCloud";
import {parseSingleChoiceData, parseTextChartData} from "../../../../utils/ChartsUtils";

function WordCloudComponent(props) {
    const chartRef = useRef(null);

    const [legendData, setLegendData] = useState([]);
    const [total, setTotal] = useState(0);

    function updateCurrentChartInfo(chart) {
        const chartNode = document.getElementById("word_cloud_wrapper_div_" + props.chartIndex + "_" + props.selectIndex);
        let newChartInfo = {
            chartText: props.questionTitle,
            chartSubtext: props.questionSubtitle,
            numAnswers: total,
            chart: chartNode
        };
        let indexToUpdate = props.chartIndex + (props.selectIndex ? props.selectIndex : 0);
        props.updateChartInfo && props.updateChartInfo(indexToUpdate, newChartInfo);
    }

    function getLegendData(legendData, isMobile) {
        const divParentStyle = {
            display: isMobile ? "flex" : "block"
        };

        const divFirstChildStyle = {
            color: '#9AA5F5',
            textAlign: isMobile ? "left" : "initial",
            width: isMobile ? "50%" : "auto"
        };

        const divSecondChildStyle = {
            textAlign: isMobile ? "right" : "initial",
            width: isMobile ? "50%" : "auto"
        };

        return legendData.length < 1 ? [] : legendData.map((x, index) =>
            (<div style={divParentStyle} key={"legend_chart_world_cloud_" + props.questionId + "_item_" + index}>
                <div style={divFirstChildStyle}>
                    <b>{x.word}: {(x.nr * 100 / total).toFixed(2)}%</b>
                </div>
                <div style={divSecondChildStyle}>{x.nr} Times</div>
            </div>)
        );
    }

    function initWordCloudChart(chart, answersData) {
        chart.data = parseSingleChoiceData(answersData);
        let wordsMaxCount = 50;
        if (props.isMobile) {
            chart.width = am4core.percent(100);
            chart.paddingTop = 20;
            chart.paddingBottom = 20;
            chart.paddingLeft = 30;
            chart.paddingRight = 30;
            wordsMaxCount = 30;
        } else {
            chart.width = props.chartConfig.width;
        }
        chart.height = props.chartConfig.height;
        chart.responsive.enabled = true;

        am4core.useTheme(am4themes_animated);
        let data = parseTextChartData(props.answersData, wordsMaxCount);
        let series = chart.series.push(new am4plugins_wordCloud.WordCloudSeries());
        series.data = data;
        series.dataFields.word = "tag";
        series.dataFields.value = "weight";
        series.minFontSize = 20;
        series.heatRules.push({
            "target": series.labels.template,
            "property": "fill",
            "min": am4core.color("#E5E8FC"),
            "max": am4core.color("#9AA5F5"),
            "dataField": "value"
        });
        let tmpLegendData = [];
        let total = 0;
        chart.events.on("ready", function (event) {
            series.dataItems.each(function (row, i) {
                let tmp = {"word": row.properties.word, "nr": row.value};
                tmpLegendData.push(tmp)
            });
            for (let i = 0; i < tmpLegendData.length; i++) {
                total = total + tmpLegendData[i].nr;
            }
            setTotal(total);
            tmpLegendData = tmpLegendData.sort((a, b) => a.nr >= b.nr ? 0 : 1);
            tmpLegendData = tmpLegendData.slice(0, 10);
            setLegendData(tmpLegendData);
        });
    }

    useLayoutEffect(() => {
        let x = am4core.create("chart_world_cloud_" + props.questionId, am4plugins_wordCloud.WordCloud);

        initWordCloudChart(x, props.answersData);

        chartRef.current = x;
        updateCurrentChartInfo(chartRef.current);
        return () => {
            x.dispose();
        };
    }, []);

    useLayoutEffect(() => {
        if(props.isMobile) {
            chartRef.current.width = am4core.percent(100);
        } else {
            chartRef.current.width = props.chartConfig.width;
        }
        chartRef.current.height = props.chartConfig.height;
        updateCurrentChartInfo(chartRef.current);
    }, [props.chartConfig]);

    useLayoutEffect(() => {
        updateCurrentChartInfo(chartRef.current);
    }, [total]);

    const wordCloudContainerStyle = {
        textAlign : 'center',
        padding: props.isMobile ? '0 0 5px' : '50px 0',
        display: props.isMobile ? 'block' : 'flex'
    };

    const chartDivStyle = {
        width: props.isMobile ? "auto" : props.chartConfig.width,
        height: props.chartConfig.height
    };

    return (
        <div style={wordCloudContainerStyle} id={"word_cloud_wrapper_div_" + props.chartIndex + "_" + props.selectIndex}>
            <div className="centered-chart" id={"chart_world_cloud_" + props.questionId} style={chartDivStyle}></div>
            <div id={"legend_chart_world_cloud_" + props.questionId} style={{padding: "30px 20px 0 20px"}}>
                {getLegendData(legendData, props.isMobile)}
            </div>
        </div>
    );
}

export default WordCloudComponent;